<template>
  <div>
    <v-row>
      <v-col sm="7">
        <p class="label">
          {{ $t("fields.doctor") }}
        </p>
        <span class="message">
          {{ $t("fields.doctorDescription") }}
        </span>
      </v-col>
      <v-col sm="5">
        <p class="label">
          {{ $t("fields.turnAmountHour") }}
        </p>
        <span class="message">
          {{ $t("fields.turnAmountHourDescription") }}
        </span>
      </v-col>
    </v-row>
    <v-row
      v-for="(vacancy, index) in vacancies"
      :key="`vacancy-${index}`"
    >
      <v-col sm="7">
        <v-select
          v-model="vacancies[index].id"
          :no-data-text="$t('noDataText')"
          :items="departmentMembers"
          item-text="name"
          item-value="id"
          :hide-details="true"
          outlined
          dense
        >
        </v-select>
      </v-col>
      <v-col sm="3">
        <v-text-field
          v-model="vacancies[index].price_per_hour"
          type="number"
          :min="0"
          :hide-details="true"
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col sm="2">
        <v-btn
          icon
          small
          color="error"
          style="margin-top: 0.3rem;"
          @click="removeVacancy(index)"
        >
          <v-icon size="24">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          block
          text
          @click="addVacancy"
        >
          <v-icon
            size="24"
            left
          >
            mdi-account-multiple-plus
          </v-icon>
          {{ $t("button.addJobVacancy") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.label {
  margin-top: 0 !important;
  margin-bottom: 0;
  font-size: 0.9rem;
}

.message {
  margin-bottom: 0.8rem;
  font-size: 0.7rem;
}
</style>

<script>
import { mdiDeleteOutline } from '@mdi/js';

export default {
  props: {
    vacancies: {
      type: Array,
      default() {
        return [];
      },
    },

    placeId: {
      type: String,
      required: true,
    },

    departmentId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      departmentMembers: [{ id: null, name: 'Vaga disponível' }],
      defaultPricePerHour: 0,

      icons: {
        mdiDeleteOutline,
      },
    };
  },

  watch: {
    defaultPricePerHour() {
      this.vacancies.forEach((vacancy) => {
        Object.assign(vacancy, {
          price_per_hour: this.defaultPricePerHour,
        });
      });
    },
  },

  async mounted() {
    this.addDefaultVacancy();
    await this.fillDepartmentMembers();
  },

  methods: {
    async fillDepartmentMembers() {
      let hospital;

      try {
        hospital = (await this.$api.hospital.getHospital(this.placeId)).data;
      } catch (error) {
        this.$store.dispatch('NOTIFICATION_ERROR', error.message);

        return;
      }

      const department = hospital.departments.find(
        (item) => item.id === this.departmentId,
      );

      const membersRequest = department.members.map(
        (member) => member.customer,
      );

      department.member_requests.forEach((member) => {
        if (member.customer !== null) {
          membersRequest.push(member.customer);
        }
      });

      this.departmentMembers = membersRequest;
    },

    fillDefaultPricePerHour(value) {
      if (value) {
        this.defaultPricePerHour = parseInt(value, 10);
      }
    },

    addDefaultVacancy() {
      if (this.vacancies.length === 0) {
        this.addVacancy();
      }
    },

    addVacancy() {
      this.vacancies.push({
        id: null,
        price_per_hour: this.defaultPricePerHour,
      });
    },

    removeVacancy(index) {
      this.vacancies.splice(index, 1);
      this.addDefaultVacancy();
    },
  },
};
</script>
